import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AuthPageManageService } from '../../../services/manage/page-manage/auth-page-manage.service';
import { Observable, fromEvent } from 'rxjs';

@Component({
  selector: 'app-need-connection',
  templateUrl: './need-connection.component.html',
  styleUrls: ['./need-connection.component.css']
})
export class NeedConnectionComponent implements OnInit {

  @Input() redirectPage: string|any;
  @Input() type: string|any;
  @Output() closeEvent = new EventEmitter<any>();

  eventHeight: Observable<any> = fromEvent(window, "resize");
  innerHeigth: any = window.innerHeight;

  constructor(
    public authPageServ: AuthPageManageService
  ) { }

  ngOnInit() {
    this.eventHeight.subscribe(event => {
      this.innerHeigth = event.currentTarget.innerHeight;
    })
  }

  /**
   * @description Ferme la popup
   * @return {void}
   */
  close(): void {
    this.closeEvent.emit();
  }

}
